document.addEventListener('DOMContentLoaded', () => {
  const loginForm = document.querySelector('form[action="/account/login"]');
  if(loginForm){
      loginForm.addEventListener('keydown', function(e){
          if(e.key === 'Enter'){
              e.preventDefault();
          }
      })
  } 
  var searchParams = new URLSearchParams(window.location.search);
  //MIXI ID
  const loginWithMIXIIDButton = document.getElementById("login__with-mixi-id-button");
  document.getElementById("mixi-id__error").style.display = "none";
  document.getElementById("mixi-create__error").style.display = "none";
  if (loginWithMIXIIDButton) {
      let formattedUrl = "";
      loginWithMIXIIDButton.addEventListener("click", async function (event) {
          event.preventDefault();
          if (!!searchParams.get("checkout_url")) {
              let urlParam = searchParams.get("checkout_url");
              formattedUrl = decodeURI(urlParam);
              localStorage.setItem("checkout_url", decodeURI(urlParam));
              window.location.href =  "https://" + `${domain}` + "/mixi/login/init?mode=login&checkout_url="+ formattedUrl;
          }
          else{
              window.location.href =  "https://" + `${domain}` + "/mixi/login/init?mode=login";
          }
      });
  }
  // 新規登録
  const newCreate = document.getElementById("loginCreate");
  newCreate.addEventListener("click", async function (event) {
      event.preventDefault();
      window.location.href = "https://" + `${domain}` + "/mixi/login/init?mode=regist";
  });
});
